import type { MouseEventHandler, ReactNode } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link as WouterLink } from 'wouter';

import { cn } from '@/ui/utils/classnames';

interface LinkProps {
  to: string;
  children: ReactNode;
  className?: string;
  onClick?: MouseEventHandler;
}

/**
 * Wraps `Link` from `wouter` and prevents `<a>` from being rendered
 * and command-click from opening a new tab.
 */
const Link = ({ to, children, className, onClick }: LinkProps) => {
  return (
    <WouterLink to={to} onClick={onClick} asChild>
      <div
        className={cn('cursor-pointer', className)}
        role="button"
        tabIndex={0}
      >
        {children}
      </div>
    </WouterLink>
  );
};

export default Link;
